@if (content) {
@if(!canShowProductResults && (client.isM || client.isS)) {
<ng-container *ngTemplateOutlet="noResultInfo" />
}
<!-- left side part -->
<div class="c-4 c-12-s c-12-m m-b-0 _sideContent wrap-s wrap-m">
    <!-- init page / feature links -->
    @if (canShowCmsSideContent) {
    @for(section of content.featureLinksSections; track section.title){
    <link-list1 [title]="section.title"
                [items]="section.links" />
    }
    }
    <!-- search results / SM -->
    <ng-container *ifSize="'SM'">
        @if (canShowTerms) {
        @for(term of mobileTerms; track term.label){
        <href class="p2 block col-4"
              [ngClass]="$first ? 'm-t-8' : 'm-t-3'"
              [link]="term.link">
            <span [innerHTML]="term.label"></span>
        </href>
        }
        }
    </ng-container>
</div>
<!-- content part -->
<div class="c-8 c-12-s c-12-m m-b-0 m-r-0 m-t-10-s m-t-10-m">
    <!-- init page / content (trending) -->
    @if(!canShowProductResults) {
    <!-- no product note in case we should be showing results -->
    @if(client.isX || client.isL ){
    <ng-container *ngTemplateOutlet="noResultInfo" />
    }
    <!-- content title -->
    <p class="s1 m-b-5"
       [sizeClass]="'SM:p-l p-r'"
       *iCms="'contentCardsTitle' of content; skipEmpty true"></p>
    <!-- content cards / XL -->
    <div [grid]="(content.contentCards?.length || 0) > 3 ? 4 : 3"
         *ifSize="'XL'"
         [gridColumnGap]="'40px'">
        @for (item of content.contentCards?.slice(0, 4); track item) {
        <href [gridColumn]="1"
              [link]="item.link || ''">
            <div class="_image">
                <img class="w-12"
                     [ratio]="1"
                     [dfImage]="item.image"
                     [alt]="item.title || ''">
            </div>
            <p class="s1 col-1 m-t-3"
               *iCms="'title' of item; skipEmpty true"></p>
            @if (item.buttonLabel) {
            <button [buttonStyle]
                    class="m-t-4">{{ item.buttonLabel }}</button>
            }
        </href>
        }
    </div>
    <!-- content cards / SM -->
    <carousel class="block m-t-5 p-l-4"
              [loop]="false"
              [autoplay]="false"
              [pagination]="false"
              [spaceBetween]="10"
              [slidesPerView]="2.4"
              [spaceBetween]="16"
              [navigation]="false"
              [scrollbar]="false"
              *ifSize="'SM'"
              imageViewRoot>
        @for (item of content.contentCards?.slice(0, 4); track item) {
        <ng-template carouselSlide>
            <href [link]="item.link || ''">
                <div class="_image">
                    <img class="w-12"
                         [ratio]="1"
                         [dfImage]="item.image"
                         [alt]="item.title || ''">
                </div>
                <p class="s1 col-1 m-t-5"
                   *iCms="'title' of item; skipEmpty true"></p>
            </href>
        </ng-template>
        }
    </carousel>
    }
    @else {
    <!-- results page / content (products) -->
    <div class="p-l-4-s p-l-4-m p-r-4-s p-r-4-m">
        <!-- content title line-->
        <div class="flex flex-justify-between flex-middle m-b-5">
            <p class="s1 col-1">{{ 'Products' | translate }}</p>
            @if(client.isS || client.isM){
            <button [buttonStyle]="'text-button'"
                    (click)="gotToSearchView()">{{'View All' | translate}}</button>
            }@else {
            <button class="s1"
                    [inlineButton]
                    (click)="gotToSearchView()">{{'view all' | translate}}</button>
            }
        </div>
        <!-- products list -->
        <div [grid]="client.sizeId > 1 ? 4 : 2"
             [gridColumnGap]="client.sizeId > 1 ? '20px' : '15px'"
             [gtmList]="{listId : 'minisearch', listName : 'Mini-search'}">

            @for (model of resultProducts; track model.id;) {
            <product [model]="model"
                     [gtmItem]="{ position: $index + 1, product : model }"
                     [gridColumn]="1" />
            }
        </div>
    </div>
    }

</div>
}

<!-- template for no result info -->
<ng-template #noResultInfo>
    @if (isSearchResult) {
    <div class="m-b-5 m-b-4-s m-b-4-m wrap-s wrap-m">
        <p class="col-1 h3 s2-s s2-m">
            {{noResultTitle}}
        </p>
        <p class="col-1 m-t-3 m-t-2-s m-t-2-m p1 p2-s p2-m">
            {{noResultSubtitle}}
        </p>
    </div>
    }
</ng-template>